import { packApi } from '@/libs/tools';
import { request } from '@koi-design/vix-tools';

// auth tree
export function feedBackApi(data) {
  return packApi({
    url: '/api/api-user/user_feedback/',
    method: 'post',
    data
  });
}

export function getDocUrlApi(params) {
  return request({
    url: '/api/api-user/user/users/get_document/',
    method: 'get',
    params
  });
}

export function getRobotUserPermissionApi(data) {
  return request({
    url: '/api/api-robot/robot/permission/get_robot_user_permission/',
    method: 'get',
    data
  });
}

export function submitForCallApi(data) {
  return packApi({
    url: '/api/api-robot/robot/voice/voice_call/',
    method: 'post',
    data
  });
}

// country code
export function getVoiceCountryCodeApi() {
  return request({
    url: '/api/api-robot/robot/voice/get_voice_country_code/',
    method: 'get'
  });
}

// language
export function getVoiceLanguageApi() {
  return request({
    url: '/api/api-robot/robot/voice/get_voice_language/',
    method: 'get'
  });
}

// check mobile valid
export function checkMobileValidApi(params) {
  return request({
    url: '/api/api-robot/robot/voice/voice_check_mobile/',
    method: 'get',
    params
  });
}
